import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Button } from '../components/Button';
interface Product {
  name: string;
  price: string;
  image: string;
  hasConfigurator?: boolean;
  category: string;
}
export function ShopAllPage() {
  const products: Product[] = [
  // Daedo PSS Systems
  {
    name: 'Gen3 PSS-Gloves USAT',
    price: '$69.00',
    image: 'https://cdn.magicpatterns.com/uploads/niYhHZHhKrMG2frXtC3Vmj/Gen3_PSS-Gloves_USAT.png',
    hasConfigurator: true,
    category: 'Daedo PSS Systems'
  }, {
    name: 'Gen3 E-Foot Gear',
    price: '$110.84',
    image: 'https://cdn.magicpatterns.com/uploads/cViGkDXcDmPVipYt9uyQmt/Gen3_E-Foot_Gear.jpg',
    hasConfigurator: true,
    category: 'Daedo PSS Systems'
  }, {
    name: 'Gen2 Transmitter Charger',
    price: '$55.00',
    image: 'https://cdn.magicpatterns.com/uploads/qEV6XsHhowYMSa1F9qrPwc/Gen2_Transmitter_Charger.jpg',
    hasConfigurator: false,
    category: 'Daedo PSS Systems'
  }, {
    name: 'Gen2 W.T. Software',
    price: '$99.00',
    image: 'https://cdn.magicpatterns.com/uploads/orVwRQoYnnfYKgyRtLXkKq/Gen2_W.T._Software.jpg',
    hasConfigurator: false,
    category: 'Daedo PSS Systems'
  }, {
    name: 'Gen2 Judge Box (Refurbished) Same Warranty',
    price: '$580.00',
    image: 'https://cdn.magicpatterns.com/uploads/bS347spy52LoYXHH7zr4qL/Gen2_Judge_Box_(Refurbished)_Same_Warranty.jpg',
    hasConfigurator: false,
    category: 'Daedo PSS Systems'
  }, {
    name: 'Gen2 Receiver',
    price: '$390.00',
    image: 'https://cdn.magicpatterns.com/uploads/w3Q65FCerZEu2ek6y4Xdyo/Gen2_Receiver.jpg',
    hasConfigurator: false,
    category: 'Daedo PSS Systems'
  }, {
    name: 'Gen2 E-HeadGear',
    price: '$399.00',
    image: 'https://cdn.magicpatterns.com/uploads/oEDj2ZvCJJBgsVECUR8bR3/Gen2_E-HeadGear.jpg',
    hasConfigurator: true,
    category: 'Daedo PSS Systems'
  }, {
    name: 'Gen2 Head Transmitter',
    price: '$390.00',
    image: 'https://cdn.magicpatterns.com/uploads/keKg2f8ApxK9KnFdbJLkPa/Gen2_Head_Transmitter.jpg',
    hasConfigurator: false,
    category: 'Daedo PSS Systems'
  }, {
    name: 'Gen2 Chest Transmitter',
    price: '$390.00',
    image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2F6-300x300.jpg',
    hasConfigurator: false,
    category: 'Daedo PSS Systems'
  }, {
    name: 'Gen2 E-Chest Gear Adult Size',
    price: '$775.00',
    image: 'https://cdn.magicpatterns.com/uploads/kfguP8tNDqA8zXYkxoyPcg/Gen2_E-Chest_Gear_Adult_Size.jpg',
    hasConfigurator: true,
    category: 'Daedo PSS Systems'
  }, {
    name: 'Gen2 E-Foot Gear',
    price: '$95.00',
    image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FDaedo%2FGeneration2%2Fepro29037_1_optimizacionweb.jpg',
    hasConfigurator: true,
    category: 'Daedo PSS Systems'
  }, {
    name: 'Daedo Truescore E-Foot Gear Magnet Tester',
    price: '$9.99',
    image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2Fdaedo-e-footgear-magnet-tester.jpg',
    hasConfigurator: false,
    category: 'Daedo PSS Systems'
  },
  // Daedo Products
  {
    name: 'Gen3-PSS-Gloves USAT',
    price: '$69.00',
    image: 'https://cdn.magicpatterns.com/uploads/fFmeJSZ4XSZWsghGfFQJi4/Gen3_PSS-Gloves_USAT.png',
    hasConfigurator: true,
    category: 'Daedo Products'
  }, {
    name: 'Gen3 E-Foot Gear',
    price: '$110.84',
    image: 'https://cdn.magicpatterns.com/uploads/gsMbZUADtxm6tprbLcqPTT/Gen3_E-Foot_Gear.jpg',
    hasConfigurator: true,
    category: 'Daedo Products'
  }, {
    name: 'Gen2 Transmitter Charger',
    price: '$55.00',
    image: 'https://cdn.magicpatterns.com/uploads/qEV6XsHhowYMSa1F9qrPwc/Gen2_Transmitter_Charger.jpg',
    hasConfigurator: false,
    category: 'Daedo Products'
  }, {
    name: 'Gen2 W.T. Software',
    price: '$99.00',
    image: 'https://cdn.magicpatterns.com/uploads/orVwRQoYnnfYKgyRtLXkKq/Gen2_W.T._Software.jpg',
    hasConfigurator: false,
    category: 'Daedo Products'
  }, {
    name: 'Gen2 Judge Box (Refurbished) Same Warranty',
    price: '$580.00',
    image: 'https://cdn.magicpatterns.com/uploads/bS347spy52LoYXHH7zr4qL/Gen2_Judge_Box_(Refurbished)_Same_Warranty.jpg',
    hasConfigurator: false,
    category: 'Daedo Products'
  }, {
    name: 'Gen2 Receiver',
    price: '$390.00',
    image: 'https://cdn.magicpatterns.com/uploads/w3Q65FCerZEu2ek6y4Xdyo/Gen2_Receiver.jpg',
    hasConfigurator: false,
    category: 'Daedo Products'
  }, {
    name: 'Gen2 E-HeadGear',
    price: '$399.00',
    image: 'https://cdn.magicpatterns.com/uploads/oEDj2ZvCJJBgsVECUR8bR3/Gen2_E-HeadGear.jpg',
    hasConfigurator: true,
    category: 'Daedo Products'
  }, {
    name: 'Gen2 Head Transmitter',
    price: '$390.00',
    image: 'https://cdn.magicpatterns.com/uploads/keKg2f8ApxK9KnFdbJLkPa/Gen2_Head_Transmitter.jpg',
    hasConfigurator: false,
    category: 'Daedo Products'
  }, {
    name: 'Gen2 Chest Transmitter',
    price: '$390.00',
    image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2F6-300x300.jpg',
    hasConfigurator: false,
    category: 'Daedo Products'
  }, {
    name: 'Gen2 E-Chest Gear Adult Size',
    price: '$775.00',
    image: 'https://cdn.magicpatterns.com/uploads/kfguP8tNDqA8zXYkxoyPcg/Gen2_E-Chest_Gear_Adult_Size.jpg',
    hasConfigurator: true,
    category: 'Daedo Products'
  }, {
    name: 'Gen2 E-Foot Gear',
    price: '$95.00',
    image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FDaedo%2FGeneration2%2Fepro29037_1_optimizacionweb.jpg',
    hasConfigurator: true,
    category: 'Daedo Products'
  }, {
    name: 'Daedo Truescore E-Foot Gear Magnet Tester',
    price: '$9.99',
    image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2Fdaedo-e-footgear-magnet-tester.jpg',
    hasConfigurator: false,
    category: 'Daedo Products'
  },
  // Wacoku Products
  {
    name: 'Wacoku Intro Colored Belt Uniform',
    price: '$37.00',
    image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FRedesign%2FWacokuIntro.jpg',
    hasConfigurator: true,
    category: 'Wacoku Products'
  }, {
    name: 'Stephen Lambdin Special Edition Wacoku Competition Uniform',
    price: '$80.00',
    image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FCustomUniform%2FStephen-Lambdin-TKD-Uniform.png',
    hasConfigurator: true,
    category: 'Wacoku Products'
  }, {
    name: 'Wacoku WTF/WT Lightweight Uniform',
    price: '$75.00',
    image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FWacoku%2FWTF%20AT210B.jpg800x800.jpg',
    hasConfigurator: true,
    category: 'Wacoku Products'
  }, {
    name: 'Wacoku WTF/WT Diamond with Ventilation Uniform',
    price: '$99.00',
    image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FWacoku%2FWTF%20AT220B.jpg',
    hasConfigurator: true,
    category: 'Wacoku Products'
  }, {
    name: 'Wacoku WTF/WT Reversible Chest Gear',
    price: '$70.00',
    image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FWacoku%2FWTF%20B132W-1.jpg800x800.jpg',
    hasConfigurator: true,
    category: 'Wacoku Products'
  }, {
    name: 'Wacoku WTF/WT Shin Guard',
    price: '$33.00',
    image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FWacoku%2FWTF%20B167.jpg800x800.jpg',
    hasConfigurator: true,
    category: 'Wacoku Products'
  }, {
    name: 'Wacoku WTF/WT Forearm Guard',
    price: '$32.00',
    image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FWacoku%2FWTF%20B166.jpg800x800.jpg',
    hasConfigurator: true,
    category: 'Wacoku Products'
  }, {
    name: 'Wacoku WTF/WT TKD Gloves',
    price: '$43.99',
    image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FWacoku%2FWTF%20B124W.jpg800x800.jpg',
    hasConfigurator: true,
    category: 'Wacoku Products'
  }, {
    name: 'Wacoku WTF/WT Headgear',
    price: '$49.99',
    image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FWacoku%2FWTF%20I201.jpg800x800.jpg',
    hasConfigurator: true,
    category: 'Wacoku Products'
  }, {
    name: 'Wacoku Foot Protection',
    price: '$39.99',
    image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FWacoku%2FWacoku-WTF-Foot-Guard.jpg',
    hasConfigurator: true,
    category: 'Wacoku Products'
  }, {
    name: 'Wacoku Groin Cup',
    price: '$26.99',
    image: 'groin-cup',
    hasConfigurator: true,
    category: 'Wacoku Products'
  }, {
    name: 'Wacoku Daedo Sports Bag and Backpack',
    price: '$53.00',
    image: 'sports-bag',
    hasConfigurator: false,
    category: 'Wacoku Products'
  }, {
    name: 'Wacoku Kick Pad',
    price: '$29.99',
    image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FWacoku%2FB464%26B465.jpg800x800.jpg',
    hasConfigurator: false,
    category: 'Wacoku Products'
  }];
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-538">
      <Header data-id="element-539" />

      <main className="flex-grow pt-32 pb-20" data-id="element-540">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-541">
          {/* Page Header */}
          <div className="text-center mb-12" data-id="element-542">
            <h1 className="text-4xl font-black text-gray-900 uppercase tracking-tight mb-4" data-id="element-543">
              Shop All Products
            </h1>
            <p className="text-lg text-gray-700 max-w-3xl mx-auto" data-id="element-544">
              Browse our complete catalog of Daedo and Wacoku Taekwondo
              equipment, including electronic scoring systems, protective gear,
              uniforms, and training accessories.
            </p>
          </div>

          {/* Products Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-545">
            {products.map((product, index) => <div key={index} className="flex items-start gap-6 p-6 bg-white border border-gray-200 rounded-lg hover:shadow-md transition-shadow" data-id="element-546">
                {/* Product Image */}
                <div className="flex-shrink-0 w-24 h-24 bg-gray-100 rounded-lg flex items-center justify-center overflow-hidden" data-id="element-547">
                  {product.image.startsWith('http') ? <img src={product.image} alt={product.name} className="w-full h-full object-contain" data-id="element-548" /> : <span className="text-xs text-gray-400 text-center px-2" data-id="element-549">
                      Product Image
                    </span>}
                </div>

                {/* Product Details */}
                <div className="flex-grow" data-id="element-550">
                  <div className="mb-2" data-id="element-551">
                    <span className="text-xs font-semibold text-blue-600 uppercase tracking-wide" data-id="element-552">
                      {product.category}
                    </span>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-553">
                    {product.name}
                  </h3>
                  <div className="mb-4" data-id="element-554">
                    <span className="text-sm text-gray-600 font-semibold" data-id="element-555">
                      Your Price
                    </span>
                    <p className="text-2xl font-black text-gray-900" data-id="element-556">
                      {product.price}
                    </p>
                  </div>

                  <div className="flex items-center gap-3" data-id="element-557">
                    <div className="flex items-center gap-2" data-id="element-558">
                      <label htmlFor={`qty-${index}`} className="text-sm font-bold text-gray-700" data-id="element-559">
                        Qty
                      </label>
                      <input type="number" id={`qty-${index}`} defaultValue="1" min="1" className="w-16 px-2 py-1 border border-gray-300 rounded text-center focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-560" />
                    </div>
                    {product.hasConfigurator ? <Button variant="primary" className="!py-2 !px-4 text-sm" data-id="element-561">
                        Configure and Buy
                      </Button> : <Button variant="primary" className="!py-2 !px-4 text-sm bg-red-600 hover:bg-red-700 focus:ring-red-600" data-id="element-562">
                        Add To Cart
                      </Button>}
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </main>

      <Footer data-id="element-563" />
    </div>;
}